import React from 'react'

export default function Confidentials() {
  return (
    <div className="w-full min-h-[70vh]">
      <div className="w-full bg-white sm:max-w-screen-2xl h-1/2 sm:px-6 mx-auto flex flex-wrap justify-between">
        <div className="w-full h-[35vh] bg-[#fccd5d] my-12 flex items-center justify-center text-[#484848] font-bold">
          <p className="text-inherit transition duration-1000 relative text-6xl after:inline-block after:absolute after:ease-in-out after:bg-[#484848] after:h-6 after:w-1/4 after:left-0 after:right-0 after:m-auto after:-bottom-14 after:transition-all after:duration-1000 hover:after:w-full">
            {" "}
            Politique de Confidentialité
          </p>
        </div>
        <div className="terms">
          <p>
          Bienvenue sur le site web du Gouvernement du Bénin consacré à l'exploitation agricole et à la planification agricole. Nous vous remercions de votre visite et souhaitons vous informer sur la manière dont nous collectons, utilisons, partageons et protégeons vos informations personnelles.
          </p>

            <h2 className='text-2xl'>Collecte des Informations</h2>
            <p>Nous utilisons les informations que nous collectons 
              pour diverses finalités, notamment pour :</p>
            <ul>
              <li>
              Fournir, améliorer et maintenir nos services liés à l'exploitation agricole et à la planification agricole au Bénin.
              </li>
              <li>
             Communiquer avec vous, répondre à vos questions et demandes, et vous informer sur les mises à jour, les événements et les nouvelles pertinentes.
              </li>
              <li>
             Analyser l'utilisation du site afin d'améliorer l'expérience utilisateur et d'adapter nos services à vos besoins.
              </li>
              <li>
            Se conformer à nos obligations légales et réglementaires.
              </li>
            </ul>
            <h2>Partage des Informations</h2>
            <p>
            Nous ne vendons, n'échangeons ni ne louons vos informations personnelles à des tiers sans votre consentement explicite, sauf dans les cas 
            prévus par la loi ou lorsque cela est nécessaire pour fournir nos services. Nous pouvons partager vos informations avec des partenaires
             de confiance, tels que des fournisseurs de services technologiques ou des organismes gouvernementaux, dans le cadre de la fourniture de 
             nos services ou pour répondre à nos obligations légales.
            </p>

            <h1>Sécurité des Données</h1>
            <p>
              La sécurité de vos données personnelles est une priorité absolue pour nous. Nous mettons en place des mesures de sécurité techniques, administratives et physiques pour protéger vos informations contre tout accès non autorisé, toute divulgation, toute altération ou toute destruction.
            </p>

            <h1>Consentement</h1>
            <p>
            En utilisant notre site, vous consentez à la collecte, à l'utilisation et au partage de vos informations 
            personnelles conformément à cette Politique de Confidentialité. 
            Si vous ne consentez pas à ces pratiques, veuillez ne pas utiliser notre site.
            </p>

            <h1>Modifications de la Politique de Confidentialité</h1>
            <p>
            Nous nous réservons le droit de mettre à jour cette Politique de Confidentialité à tout moment. Nous vous informerons de toute modification importante en affichant un avis sur notre site ou en vous envoyant une notification directe.
             Nous vous recommandons de consulter régulièrement cette Politique de Confidentialité pour prendre connaissance des éventuelles modifications.
            </p>

            <h1>Contact</h1>
            <p>
            Si vous avez des questions ou des préoccupations concernant notre Politique de Confidentialité ou nos pratiques en matière de confidentialité des données, veuillez nous contacter à l'adresse suivante :  <a href="mailto:maep@gouv.bj">maep@gouv.bj</a>.
            </p>


            <h1>Dernière mise à jour : 05/04/2024</h1>
          
            <h4>
            Nous vous remercions de votre confiance et de votre intérêt pour l'exploitation agricole et la planification agricole au Bénin.
            </h4>
        </div>
      </div>
    </div>
  )
}
